export const baseUrl = "https://api.themoviedb.org/3";
// export const api_key = "a050af4c5354d8e3d4d8d50330fb50d9";
export const image_url = "https://image.tmdb.org/t/p";




export const movieUrl = `${baseUrl}/movie/`